import { TeamContext } from "@redotech/redo-web/context/team-context";
import { ShopifyStorefrontClient } from "@redotech/shopify-storefront";
import { ReactNode, createContext, memo, useContext, useEffect } from "react";
import { PermissionsContext } from "./auth/permissions-context";
import { UserContext } from "./user";

export interface OnboardingData {
  averageWeight?: number;
}

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  ReloadTeamContext,
  TeamContext,
} from "@redotech/redo-web/context/team-context";

export const StorefrontClientContext = createContext<
  ShopifyStorefrontClient | undefined
>(undefined);

export const TeamAndUserRequired = memo(function TeamAndUserRequired({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const team = useContext(TeamContext);
  const user = useContext(UserContext);
  const permissions = useContext(PermissionsContext);

  useEffect(() => {
    const timeoutId = setTimeout(
      () => {
        if (!team || !user || !permissions) {
          console.error(
            `[DEBUG] Still rendering null. Team: ${!!team}, User: ${!!user}, Permissions: ${!!permissions}`,
          );
        }
      },
      Temporal.Duration.from({ seconds: 10 }).total("milliseconds"),
    );
    return () => clearTimeout(timeoutId);
  }, [team, user, permissions]);

  if (!team || !user || !permissions) {
    return null;
  } else {
    return children;
  }
});

export const OnboardingAverageProductWeightContext = createContext<
  OnboardingData | undefined
>(undefined);
